import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  padding-top: 16px;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 100%;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.purple2};
  border: 1px solid ${({ theme }) => theme.colors.purple7};
  position: relative;
`;

export const GreenDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -6px;
  background-color: ${({ theme }) => theme.colors.green7};
  border: 2px solid ${({ theme }) => theme.colors.white};
`;

export const TitleWrapper = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
`;

export const DateWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black6};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const DaysCounter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 8px 12px;
  min-width: 48px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const DaysNumber = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const DaysText = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
